import * as creditActions from "./../creditSettlement/actions";
import * as actions from "./user.actions";

import _ from "underscore";
import * as loanActions from "./actions";

import moment from "moment";

let initialState = {
  fetching: false,
  fetched: false,
  error: null,

  detailsFetching: false,
  detailsFetched: false,
  detailsError: null,

  table: {
    currentFilter: null,
    pagination: { page: 1, take: 10 },
  },
  data: [],
};

const loans = (state = initialState, action) => {
  switch (action.type) {
    //FETCHING SETTLEMENTS AND DETAILS
    case creditActions.CREDIT_SETTLEMENT_FOR_USER_GET_REQUEST:
      return Object.assign({}, state, {
        fetching: true,
        fetchError: null,
        data: [],
        selected: action.additionalData,
      });

    case creditActions.CREDIT_SETTLEMENT_FOR_USER_GET_SUCCESS: {
      let data = Array.isArray(action.response.Response)
        ? action.response.Response
        : [action.response.Response];

      return Object.assign({}, state, {
        fetching: false,
        fetched: true,
        data,
      });
    }
    case creditActions.CREDIT_SETTLEMENT_FOR_USER_GET_ERROR:
      return Object.assign({}, state, {
        fetching: false,
        error: action.error,
      });

    case creditActions.CREDIT_SETTLEMENT_FOR_USER_GET_DETAILS_REQUEST:
      return Object.assign({}, state, {
        detailsFetching: true,
        detailsError: null,
      });
    case creditActions.CREDIT_SETTLEMENT_FOR_USER_GET_DETAILS_SUCCESS: {
      let forId = action.additionalData;

      let itemToUpdateIndex = _.findIndex(state.data, (item) => {
        return item.Id === forId;
      });

      // There is a mismatch between backend objects it needs to be done like that unfortunately ;/
      // TODO change it later
      action.response.Id = action.response.IntId;
      action.response = {
        ...state.data[itemToUpdateIndex],
        ...action.response,
      };

      return Object.assign({}, state, {
        detailsFetching: false,
        detailsFetched: true,
        data: [
          ...state.data.slice(0, itemToUpdateIndex),
          action.response,
          ...state.data.slice(itemToUpdateIndex + 1),
        ],
      });
    }
    case creditActions.CREDIT_SETTLEMENT_FOR_USER_GET_DETAILS_ERROR:
      return Object.assign({}, state, {
        detailsFetching: false,
        detailsError: action.error,
      });

    //OTHER
    case actions.USER_LOAN_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        table: Object.assign({}, state.table, {
          pagination: Object.assign({}, state.table.pagination, {
            page: action.page,
          }),
        }),
      });

    case actions.USER_LOAN_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        table: Object.assign({}, state.table, {
          currentFilter: Object.assign({}, state.table.currentFilter, {
            ...action.filter,
          }),
        }),
      });
    // Getting full repayment
    case actions.USER_GET_REPAYMENT_REQUEST: {
      let id = action.dataSent.CreditId;

      let loanIndex = _.findIndex(state.data, (loan) => {
        return loan.Id == id;
      });

      let loanItem = Object.assign({}, state.data[loanIndex]);

      loanItem.fullRepaymentLoading = true;

      return Object.assign({}, state, {
        data: [
          ...state.data.slice(0, loanIndex),
          loanItem,
          ...state.data.slice(loanIndex + 1),
        ],
      });
    }
    case actions.USER_GET_REPAYMENT_SUCCESS: {
      let id = action.dataSent.CreditId;

      let loanIndex = _.findIndex(state.data, (loan) => {
        return loan.Id == id;
      });

      let loanItem = Object.assign({}, state.data[loanIndex]);

      loanItem.fullRepayment = action.response;
      loanItem.fullRepaymentLoading = false;

      return Object.assign({}, state, {
        data: [
          ...state.data.slice(0, loanIndex),
          loanItem,
          ...state.data.slice(loanIndex + 1),
        ],
      });
    }
    case actions.USER_LOAN_REPAYMENT_REQUEST: {
      let guid = action.dataSent.CreditId;

      let loanIndex = _.findIndex(state.data, (loan) => {
        return loan.Guid == guid;
      });

      let loanItem = Object.assign({}, state.data[loanIndex]);

      loanItem.fullRepaymentCreatedByAdminLoading = true;
      loanItem.fullRepaymentCreatedByAdminError = false;

      return Object.assign({}, state, {
        data: [
          ...state.data.slice(0, loanIndex),
          loanItem,
          ...state.data.slice(loanIndex + 1),
        ],
      });
    }
    //data: { LoanId: loanId, Amount: amount, BankReceiveDate: date },
    case actions.USER_LOAN_REPAYMENT_SUCCESS: {
      let guid = action.dataSent.CreditId;

      let loanIndex = _.findIndex(state.data, (loan) => {
        return loan.Guid == guid;
      });

      let loanItem = Object.assign({}, state.data[loanIndex]);

      loanItem.fullRepaymentCreatedByAdminDone = action.response;
      loanItem.fullRepaymentCreatedByAdminLoading = false;

      return Object.assign({}, state, {
        data: [
          ...state.data.slice(0, loanIndex),
          loanItem,
          ...state.data.slice(loanIndex + 1),
        ],
      });
    }
    case actions.USER_LOAN_REPAYMENT_ERROR: {
      let guid = action.dataSent.CreditId;

      let loanIndex = _.findIndex(state.data, (loan) => {
        return loan.Guid == guid;
      });

      let loanItem = Object.assign({}, state.data[loanIndex]);

      loanItem.fullRepaymentCreatedByAdminError = true;
      loanItem.fullRepaymentCreatedByAdminLoading = false;

      return Object.assign({}, state, {
        data: [
          ...state.data.slice(0, loanIndex),
          loanItem,
          ...state.data.slice(loanIndex + 1),
        ],
      });
    }
    // Fee remove
    case actions.USER_REMOVE_FEES_REQUEST: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      let toChange = Object.assign({}, state.data[toChangeIndex], {
        sending: true,
        sent: false,
        error: null,
      });

      return Object.assign({}, state, {
        data: [
          ...state.data.slice(0, toChangeIndex),
          toChange,
          ...state.data.slice(toChangeIndex + 1),
        ],
      });
    }
    case actions.USER_REMOVE_FEES_SUCCESS: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      let toChange = Object.assign({}, state.data[toChangeIndex], {
        sending: false,
        sent: true,
        error: null,
      });

      return Object.assign({}, state, {
        data: [
          ...state.data.slice(0, toChangeIndex),
          toChange,
          ...state.data.slice(toChangeIndex + 1),
        ],
      });
    }
    case actions.USER_REMOVE_FEES_ERROR: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      let toChange = Object.assign({}, state.data[toChangeIndex], {
        sending: false,
        sent: false,
        error: action.error,
      });

      return Object.assign({}, state, {
        data: [
          ...state.data.slice(0, toChangeIndex),
          toChange,
          ...state.data.slice(toChangeIndex + 1),
        ],
      });
    }

    // Credit settlement actions
    case creditActions.CREDIT_SETTLEMENT_SET_DCA_PROCESS_REQUEST: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      if (toChangeIndex > -1) {
        let toChange = Object.assign({}, state.data[toChangeIndex], {
          settingDCA: false,
          setDCA: false,
          setDCAError: null,
        });

        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, toChangeIndex),
            toChange,
            ...state.data.slice(toChangeIndex + 1),
          ],
        });
      }

      return state;
    }
    case creditActions.CREDIT_SETTLEMENT_SET_DCA_PROCESS_SUCCESS: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      if (toChangeIndex > -1) {
        let toChange = Object.assign({}, state.data[toChangeIndex], {
          CreditStage: "DCAProcess",
          DCAMonthlyData: {},
          settingDCA: false,
          setDCA: true,
          setDCAError: null,
        });

        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, toChangeIndex),
            toChange,
            ...state.data.slice(toChangeIndex + 1),
          ],
        });
      }

      return state;
    }
    case creditActions.CREDIT_SETTLEMENT_SET_DCA_PROCESS_ERROR: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      if (toChangeIndex > -1) {
        let toChange = Object.assign({}, state.data[toChangeIndex], {
          settingDCA: false,
          setDCA: false,
          setDCAError: action.error,
        });

        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, toChangeIndex),
            toChange,
            ...state.data.slice(toChangeIndex + 1),
          ],
        });
      }

      return state;
    }
    case creditActions.CREDIT_SETTLEMENT_CLOSE_DCA_PROCESS_REQUEST: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      if (toChangeIndex > -1) {
        let toChange = Object.assign({}, state.data[toChangeIndex], {
          closingDCA: false,
          closedDCA: false,
          closingDCAError: null,
        });

        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, toChangeIndex),
            toChange,
            ...state.data.slice(toChangeIndex + 1),
          ],
        });
      }

      return state;
    }
    case creditActions.CREDIT_SETTLEMENT_CLOSE_DCA_PROCESS_SUCCESS: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      if (toChangeIndex > -1) {
        let toChange = Object.assign({}, state.data[toChangeIndex], {
          CreditStage: "CreditManuallyClosedInDCA",
          closingDCA: false,
          closedDCA: true,
          closingDCAError: null,
        });

        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, toChangeIndex),
            toChange,
            ...state.data.slice(toChangeIndex + 1),
          ],
        });
      }

      return state;
    }
    case creditActions.CREDIT_SETTLEMENT_CLOSE_DCA_PROCESS_ERROR: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      if (toChangeIndex > -1) {
        let toChange = Object.assign({}, state.data[toChangeIndex], {
          closingDCA: false,
          closedDCA: false,
          closingDCAError: action.error,
        });

        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, toChangeIndex),
            toChange,
            ...state.data.slice(toChangeIndex + 1),
          ],
        });
      }

      return state;
    }

    case loanActions.LOAN_SET_TO_DISPUTED_SUCCESS: {
      const id = action.dataSent.LoanId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id === id;
      });

      if (toChangeIndex > -1) {
        let toChange = Object.assign({}, state.data[toChangeIndex], {
          DisputedSince: moment(new Date()).format("YYYY-MM-DD"),
        });

        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, toChangeIndex),
            toChange,
            ...state.data.slice(toChangeIndex + 1),
          ],
        });
      }

      return state;
    }

    case loanActions.LOAN_SET_TO_UNDISPUTED_SUCCESS: {
      const id = action.dataSent.LoanId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id === id;
      });

      if (toChangeIndex > -1) {
        let toChange = Object.assign({}, state.data[toChangeIndex], {
          DisputedSince: null,
        });

        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, toChangeIndex),
            toChange,
            ...state.data.slice(toChangeIndex + 1),
          ],
        });
      }

      return state;
    }

    default:
      return state;
  }
};

export default loans;
